import type { IIntegrationFormData } from "src/integrations/forms/IIntegrationFormData";
import {
  type IIntegrationFormDataShopify,
  integrationDataToIntegrationShopify,
  integrationToIntegrationDataShopify,
} from "src/integrations/forms/shopify/IIntegrationFormDataShopify";
import type { IntegrationShopify } from "src/integrations/objects/IntegrationShopify";
import type { IntegrationType } from "src/integrations/objects/IntegrationType";

export type IIntegrationFormDataShopifyOrder = IIntegrationFormDataShopify;

export function integrationDataToIntegrationShopifyOrder(
  integrationType: IntegrationType,
  integrationData: Partial<IIntegrationFormData>,
  integrationUuid?: string,
): Partial<IntegrationShopify> {
  return integrationDataToIntegrationShopify(
    integrationType,
    integrationData,
    integrationUuid,
  );
}

export function integrationToIntegrationDataShopifyOrder(
  integrationType: IntegrationType,
  integration: IntegrationShopify,
): Partial<IIntegrationFormDataShopifyOrder> {
  return integrationToIntegrationDataShopify(integrationType, integration);
}
